//Vista de invitaciones que se han enviado y aún no respondido 

//Imports 
import React from 'react';
import {Table, Col, Row, Input, Breadcrumb, Card, Button, notification, Spin} from "antd";
import axios from 'axios';
import {visitConsumerReenviarMail} from "./VisitConsumer";


const {Search} = Input;

//Componente Historial Invitaciones 
class InvitesHistory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: "",
            CheckboxGroup: "",
            visitaSinCargar: true,
            searchValue: "",
            //Total number
            total: 0,
            //Define query parameters
            query: {
                pageNumber: 1,
                pageSize: 10
            }
        }
    };

    //Función que se corre al cargar el componente 
    getList = () => {
        if(window.Roles !== null){
            this.setState({visitaSinCargar: true})
            //Tomamos todas las solicitudes de visita que nos entrega la api
            axios.post(window.ENV.API_URL + '/mis_pendientes_listado/',{
                    page_number: this.state.query.pageNumber,
                    page_size: this.state.query.pageSize,
                    key_find: this.state.searchValue
                }, {
                    headers: {
                        Authorization: window.Token
                    }
            })
            .then((response_visit) => {
                let i = 1
                var visitasF = []
                if (response_visit.data.data) {
                    visitasF = response_visit.data.data.map(info => {
                        return {...info, key: i++}
                    });
                }
                this.setState({data: visitasF,visitaSinCargar: false, total: response_visit.data.pagination.count})
                return visitasF
            });
        }
    };

    //Cargamos el componente 
    componentDidMount() {
        this.getList();
    };

    handleChangeSearch = (e) => {
        this.setState({searchValue: e.target.value});
    }

    reenviarMails = () => {
        let a = this.state.rows;
        let mails = [];
        let enlaces = [];
        let info = {
            "email": [],
            "enlace": [],
        };
        let datosMails = this.state.data;
        for (let ix=0;ix<a.length;ix++){
            if(a[ix]){
                for (let px=0;px<datosMails.length;px++){
                    if(datosMails[px].EMAIL === a[ix].EMAIL){
                        mails.push(datosMails[px].EMAIL);
                        enlaces.push(datosMails[px].ENLACE_URL)
                        break;
                    }
                    
                }
            }
        }
        info.email = mails;
        info.enlace = enlaces;
        if (mails.length != enlaces.length || mails.length === 0 || enlaces.length === 0) {
            return
        }
        visitConsumerReenviarMail(info).then(res => {
            if (res.data.verificacion == null) {
                notification.open({
                    message: "Reenvio exitoso",
                    description: "éxito al reenviar mails.",
                    type: "success",
                    duration: 0,
                });
            }
            else {
                let mailsNoEnviados = ""
                for(let ix=0;ix<res.data.verificacion.length;ix++){
                    mailsNoEnviados = mailsNoEnviados + res.data.verificacion[ix] + "," + " "
                }
                mailsNoEnviados = mailsNoEnviados.substring(0,mailsNoEnviados.length-2)
                notification.open({
                    message: "Error",
                    description: "No se pudieron reenviar a los siguientes mails: " + mailsNoEnviados,
                    type: "error",
                    duration: 0,
                });
            }});
    };

    render() {
        //Datos para las tabla
        const rowSelection = {
            onChange: (selectedRowKeys, selectedRows) => {
                let a = selectedRows;
                this.setState({rows: a});
                console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                console.log(this.state.rows);
            },
          };

        const columns = [
            {
                title: <label className='prorroga-title'>Email de contacto</label>,
                dataIndex: "",
                render: text => <label className='prorroga-body-data'>{text.EMAIL}</label>
            },
            {
                title: <label className='prorroga-title'>Fecha de Ingreso</label>,
                dataIndex: "",
                render: text => <label className='prorroga-body-data'>{text.FECHA_CREACION.substring(8,10) + '-' + text.FECHA_CREACION.substring(5,7) + '-' + text.FECHA_CREACION.substring(0,4)}</label>
            },
            {
                title: <label className='prorroga-title'>Sponsor</label>,
                dataIndex: "",
                render: text => <label className='prorroga-body-data'>{text.PATROCINADOR}</label>
            },

        ];
        return (
            <div>
                <Spin tip="Cargando Datos…" spinning={this.state.visitaSinCargar}>
                <Breadcrumb>
                    <Breadcrumb.Item>
                        <a href="/main">Menú principal</a>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>Invitaciones Pendientes</Breadcrumb.Item>
                </Breadcrumb>

                <Card>
                    <div style={{fontSize:"25px", color:"#1978B8"}}><b>Invitaciones Pendientes</b></div>
                    <Row>
                        <Input className="search-input" style={{margin: 10}} placeholder="Buscar por palabras claves para Email o Sponsor" onBlur={this.handleChangeSearch}/>
                        <Button className="global-principal-button" style={{margin: 10}} onClick={() => this.getList()}>BUSCAR</Button>
                    </Row>
                    <Row>
                        <Col span={24}>
                            <Table rowSelection={{type: 'checkbox', ...rowSelection,}} columns={columns} dataSource={this.state.data}
                                // Add paging component
                                pagination={{
                                    // Set the total number
                                    total: this.state.total,
                                    // Option to set page number
                                    pageSizeOptions: ["5","10", "20", "50"],
                                    // display the total number
                                    showTotal: total => `Total ${total} visitas`,
                                    // Is it possible to change pageSize
                                    showSizeChanger: true,
                                    current: this.state.query.pageNumber,
                                    // When changing the page number
                                    onChange: ((page, pageSize) => {
                                        this.setState({
                                            query: {
                                                pageNumber: page,
                                                pageSize: pageSize
                                            }
                                        }, () => {
                                            this.getList()
                                        })
                                    }),
                                    // callback for pageSize change
                                    onShowSizeChange: (page, pageSize) => {
                                        // this.state.visitaSinCargar = true;
                                        this.setState({
                                            query: {
                                                pageNumber: page,
                                                pageSize: pageSize
                                            }
                                        }, () => {
                                            this.getList()
                                        })
                                    }
                                }}
                            />
                        </Col>
                    </Row>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button type="primary" onClick={this.reenviarMails}>REENVIAR MAILS</Button>
                    </div>
                </Card>
                </Spin>
            </div>
        );
    }
}

export default InvitesHistory;